import { localStore } from "../../data/io/localStore"

const flag_prefix = "flags:"
export type FlagsLocalType = "ads_popup_shown" | "fill_profile_reminder_hide"
const daySeconds = 3600 * 24;


export const useFlagsLocal = () => {

    const epochNow = Math.round(new Date().valueOf() / 1000);

    return {
        epochNow: epochNow,
        daySeconds: 3600 * 24,
        isEpochMoreThanXDaysAgo: (epoch: number, days: number) => {
            return epoch < (epochNow - daySeconds * days);
        },
        get: (e: FlagsLocalType): number => {
            const ret = localStore.get<string>(flag_prefix + e);
            if (!!ret) {
                return (parseInt(ret) ?? 0) as number;
            }
            return 0;
        },
        setNow: (e: FlagsLocalType) => {
            const n = Math.round(new Date().valueOf() / 1000);
            return localStore.set(flag_prefix + e, n.toString());
        },
        getOrgBoolFlag: (orgId: string, flag: FlagsLocalType) => {
            return !!localStore.get<boolean>(flag_prefix + orgId + ":" + flag);
        },
        setOrgBoolFlag: (orgId: string, flag: FlagsLocalType, e: boolean) => {
            return localStore.set(flag_prefix + orgId + ":" + flag, e.toString());
        }
    }
}